import {
  red,
  orange,
  amber,
  yellow,
  lime,
  green,
  emerald,
  teal,
  cyan,
  sky,
  blue,
  indigo,
  violet,
  purple,
  fuchsia,
  pink,
  rose,
  gray,
} from "tailwindcss/colors";
import times from "util/times";
import { motion } from "framer-motion";

interface Props {
  height: number;
  width: number;
  percentComplete: number;
  failed?: boolean;
}

const colors = [
  red,
  orange,
  amber,
  yellow,
  lime,
  green,
  emerald,
  teal,
  cyan,
  sky,
  blue,
  indigo,
  violet,
  purple,
  fuchsia,
  pink,
  rose,
];

export default function RainbowBackground({
  width,
  height,
  percentComplete,
  failed,
}: Props) {
  const circlesPerCol = width > 700 ? 2 : 1;
  const cols = colors.length * circlesPerCol;
  const circleRadius = width / colors.length / circlesPerCol;
  const heightCount = Math.ceil(height / circleRadius);
  const columnsComplete = percentComplete * cols;
  const xOffset = width > 700 ? 4 : 4;

  return (
    <div className={"absolute inset-0 -z-10 flex scale-[103%]"}>
      {times(colors.length, (col) => (
        <div key={col}>
          {times(heightCount, (row) => {
            return (
              <div key={row} className="flex">
                {times(circlesPerCol, (circle) => {
                  const active = columnsComplete > col * circlesPerCol + circle;

                  return (
                    <motion.div
                      key={circle}
                      initial={false}
                      animate={active ? "active" : "inactive"}
                      style={{
                        zIndex: width > 700 ? circle + col + row : col * row,
                        width: circleRadius,
                        height: circleRadius,
                        border: `1px solid `,
                      }}
                      transition={{
                        delay: 0.002 * (col + circle) + row * 0.025,
                        duration: 0.05,
                      }}
                      variants={{
                        inactive: {
                          transform: `scale(1) translateX(${
                            row % 2 > 0 ? 4 : -4
                          }px)`,
                          backgroundColor: "#000",
                          borderColor: gray[900],
                        },
                        active: {
                          transform: `scale(1) translateX(${
                            row % 2 > 0 ? xOffset : -xOffset
                          }px)`,
                          borderColor: failed ? red[600] : colors[col][600],
                          backgroundColor: failed ? red[500] : colors[col][500],
                        },
                      }}
                    />
                  );
                })}
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
}
